import http from '../http'

export async function login(payload) {
    return await http.post('/auth/login', payload)
}

/** 开发环境免密直登，仅传递账号名；后端仅在 dev profile 暴露该接口。 */
export async function devDirectLogin(payload) {
    return await http.post('/auth/dev-direct-login', payload)
}

export async function fetchLoginAccounts() {
    return await http.post('/auth/login-accounts')
}

export async function fetchCurrentUser() {
    return await http.post('/auth/me')
}

/** 首次登录或主动修改当前后台账号密码。 */
export async function changePassword(payload) {
    return await http.post('/auth/change-password', payload)
}

export async function fetchCurrentUserSilently(options = {}) {
    const response = await fetch('/api/auth/me', {
        method: 'POST',
        credentials: 'include',
        signal: options.signal,
        headers: {'Content-Type': 'application/json'},
    })
    const result = await response.json()
    if (response.ok && result.code === 200) {
        return result.data
    }
    throw new Error(result.message || '登录状态已失效，请重新登录。')
}

export async function logout() {
    return await http.post('/auth/logout')
}
